import { useState, useEffect } from 'react';
import { Fade } from '@mui/material';

interface StringRotationProps {
    messages: string[];
    intervalMs?: number;
    fadeMs?: number;
}

export function StringRotation({ messages, intervalMs = 2000, fadeMs = 300 }: StringRotationProps) {
    const [index, setIndex] = useState(0);
    const [show, setShow] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setShow(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % messages.length);
                setShow(true);
            }, fadeMs);
        }, intervalMs);
        return () => clearInterval(interval);
    }, [messages.length, intervalMs, fadeMs]);

    return (
        <Fade in={show} timeout={fadeMs}>
            <span key={index}>{messages[index]}</span>
        </Fade>
    );
}
